<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div style="width: 100%;height: 20px;"></div>
		<el-button type="primary" icon="el-icon-search" size="mini">查询</el-button>
		<router-link :to="{ name: 'cggl_ddcl_cgdd' }" class="ml-2"><el-button type="success" size="mini" icon="el-icon-truck">采购下单</el-button></router-link>
		<!-- 商品列表 -->
		<el-table class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini">
			<el-table-column type="selection" width="45" align="center">
			</el-table-column>
			<el-table-column align="center" prop="id" width="60" label="编号">
			</el-table-column>
			<el-table-column label="产品名称" width="140">
				<template slot-scope="scope">
					<div class="media"  style="display: flex;align-items: center;">
						{{scope.row.title}}
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="产品编码">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="条码">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="计量单位">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="预警库存">
			</el-table-column>
			<el-table-column align="center" width="120" label="产品分类">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>大机械
					</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="120" label="产品类型">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain>大型商品
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
				 :total="page.total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-footer>
	</div>
	
</template>

<script>
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import { mapState } from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入

		data() {
			return {
				tableData:[]
			}
		},
		// 生命周期监听页面
		methods: {
			
		},
	}
</script>

<style>
</style>
